import { ActionIcon, Title } from '@mantine/core';
import { useUnit } from 'effector-react';
import { ChevronLeft } from 'lucide-react';
import { useBreakpoint } from 'shared/lib';
import { router } from 'shared/routing';
import { accountPageModel } from '../../model';
import cls from './account-page-heading.module.scss';

export const AccountPageHeading = () => {
	const [name, back] = useUnit([accountPageModel.$accountName, router.back]);

	const md = useBreakpoint('md');

	return (
		<div className={cls.accountPageHeading}>
			<ActionIcon
				variant='outline'
				onClick={back}
			>
				<ChevronLeft />
			</ActionIcon>
			<Title
				order={1}
				size={md ? 'h1' : 'h3'}
				className={cls.accountPageHeadingTitle}
			>
				{name}
			</Title>
		</div>
	);
};
